export enum CreateContactOptions {
  AUTO = 'auto',
  MANUAL = 'manual',
}
